import { RuleAction } from "@/types"
import { FieldDataTypes, readOnlyFieldTypes } from "@/types/fieldTypes"

export const nonAddableFieldTypes: string[] = [
	FieldDataTypes.CaseNumber,
	FieldDataTypes.TimeSpent
]

export interface AllowFieldTypeRequest {
	userRole: boolean
}

const defaultRequest: AllowFieldTypeRequest = {
	userRole: false
}

export function getNonActionSettableFieldTypes (request: AllowFieldTypeRequest = defaultRequest): string[] {
	let excludedTypes : string[] = [
		...readOnlyFieldTypes,
		FieldDataTypes.ListData,
		FieldDataTypes.ListMultiple,
		FieldDataTypes.FileOnly
	]

	if (!request.userRole) {
		excludedTypes.push(FieldDataTypes.UserRole)
	}

	return excludedTypes
}

export function settingsValueToJsonString (action: RuleAction, settingsId: string): void {
	if (action && action.settings[settingsId]) {
		action.settings[settingsId] = JSON.stringify(action.settings[settingsId])
	}
}

export function settingsJsonStringToValue (action: RuleAction, settingsId: string): void {
	if (action && action.settings[settingsId]) {
		action.settings[settingsId] = JSON.parse(action.settings[settingsId] as string)
	}
}
